// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/connector.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ResourceType } from "./resource";
import { Struct } from "../../../google/protobuf/struct";
import { AssetRef } from "./asset";
import { Any } from "../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceCleanupRequest
 */
export interface ConnectorServiceCleanupRequest {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 2
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceCleanupResponse
 */
export interface ConnectorServiceCleanupResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorMetadata
 */
export interface ConnectorMetadata {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string help_url = 2
     */
    helpUrl: string;
    /**
     * @generated from protobuf field: c1.connector.v2.AssetRef icon = 3
     */
    icon?: AssetRef;
    /**
     * @generated from protobuf field: c1.connector.v2.AssetRef logo = 4
     */
    logo?: AssetRef;
    /**
     * @generated from protobuf field: google.protobuf.Struct profile = 5
     */
    profile?: Struct;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 6
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * @generated from protobuf field: c1.connector.v2.ConnectorCapabilities capabilities = 8
     */
    capabilities?: ConnectorCapabilities;
    /**
     * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema account_creation_schema = 9
     */
    accountCreationSchema?: ConnectorAccountCreationSchema;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialDetails
 */
export interface CredentialDetails {
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialDetailsAccountProvisioning capability_account_provisioning = 1
     */
    capabilityAccountProvisioning?: CredentialDetailsAccountProvisioning;
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialDetailsCredentialRotation capability_credential_rotation = 2
     */
    capabilityCredentialRotation?: CredentialDetailsCredentialRotation;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialDetailsAccountProvisioning
 */
export interface CredentialDetailsAccountProvisioning {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options = 1
     */
    supportedCredentialOptions: CapabilityDetailCredentialOption[];
    /**
     * @generated from protobuf field: c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option = 2
     */
    preferredCredentialOption: CapabilityDetailCredentialOption;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialDetailsCredentialRotation
 */
export interface CredentialDetailsCredentialRotation {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options = 1
     */
    supportedCredentialOptions: CapabilityDetailCredentialOption[];
    /**
     * @generated from protobuf field: c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option = 2
     */
    preferredCredentialOption: CapabilityDetailCredentialOption;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorCapabilities
 */
export interface ConnectorCapabilities {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.ResourceTypeCapability resource_type_capabilities = 1
     */
    resourceTypeCapabilities: ResourceTypeCapability[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Capability connector_capabilities = 2
     */
    connectorCapabilities: Capability[];
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialDetails credential_details = 3
     */
    credentialDetails?: CredentialDetails;
}
/**
 * @generated from protobuf message c1.connector.v2.CapabilityPermission
 */
export interface CapabilityPermission {
    /**
     * @generated from protobuf field: string permission = 1
     */
    permission: string;
}
/**
 * @generated from protobuf message c1.connector.v2.CapabilityPermissions
 */
export interface CapabilityPermissions {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.CapabilityPermission permissions = 1
     */
    permissions: CapabilityPermission[];
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceTypeCapability
 */
export interface ResourceTypeCapability {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceType resource_type = 1
     */
    resourceType?: ResourceType;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Capability capabilities = 2
     */
    capabilities: Capability[];
    /**
     * @generated from protobuf field: c1.connector.v2.CapabilityPermissions permissions = 3
     */
    permissions?: CapabilityPermissions;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceGetMetadataRequest
 */
export interface ConnectorServiceGetMetadataRequest {
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceGetMetadataResponse
 */
export interface ConnectorServiceGetMetadataResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.ConnectorMetadata metadata = 1
     */
    metadata?: ConnectorMetadata;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceValidateRequest
 */
export interface ConnectorServiceValidateRequest {
}
/**
 * NOTE(morgabra) We're expecting correct grpc.Status responses
 * for things like 401/403/500, etc
 *
 * @generated from protobuf message c1.connector.v2.ConnectorServiceValidateResponse
 */
export interface ConnectorServiceValidateResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string sdk_version = 2
     */
    sdkVersion: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema
 */
export interface ConnectorAccountCreationSchema {
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> field_map = 1
     */
    fieldMap: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.Field
 */
export interface ConnectorAccountCreationSchema_Field {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool required = 2
     */
    required: boolean;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: string placeholder = 4
     */
    placeholder: string;
    /**
     * @generated from protobuf field: int32 order = 5
     */
    order: number;
    /**
     * @generated from protobuf field: bool deprecated = 6
     */
    deprecated: boolean;
    /**
     * @generated from protobuf oneof: field
     */
    field: {
        oneofKind: "stringField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.StringField string_field = 100
         */
        stringField: ConnectorAccountCreationSchema_StringField;
    } | {
        oneofKind: "boolField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.BoolField bool_field = 101
         */
        boolField: ConnectorAccountCreationSchema_BoolField;
    } | {
        oneofKind: "stringListField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.StringListField string_list_field = 102
         */
        stringListField: ConnectorAccountCreationSchema_StringListField;
    } | {
        oneofKind: "intField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.IntField int_field = 103
         */
        intField: ConnectorAccountCreationSchema_IntField;
    } | {
        oneofKind: "mapField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.MapField map_field = 104
         */
        mapField: ConnectorAccountCreationSchema_MapField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringField
 */
export interface ConnectorAccountCreationSchema_StringField {
    /**
     * @generated from protobuf field: optional string default_value = 1
     */
    defaultValue?: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.BoolField
 */
export interface ConnectorAccountCreationSchema_BoolField {
    /**
     * @generated from protobuf field: optional bool default_value = 1
     */
    defaultValue?: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringListField
 */
export interface ConnectorAccountCreationSchema_StringListField {
    /**
     * @generated from protobuf field: repeated string default_value = 1
     */
    defaultValue: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.IntField
 */
export interface ConnectorAccountCreationSchema_IntField {
    /**
     * @generated from protobuf field: optional int32 default_value = 1
     */
    defaultValue?: number;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.MapField
 */
export interface ConnectorAccountCreationSchema_MapField {
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> default_value = 1
     */
    defaultValue: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
}
/**
 * @generated from protobuf enum c1.connector.v2.Capability
 */
export enum Capability {
    /**
     * @generated from protobuf enum value: CAPABILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CAPABILITY_PROVISION = 1;
     */
    PROVISION = 1,
    /**
     * @generated from protobuf enum value: CAPABILITY_SYNC = 2;
     */
    SYNC = 2,
    /**
     * @generated from protobuf enum value: CAPABILITY_EVENT_FEED = 3;
     */
    EVENT_FEED = 3,
    /**
     * @generated from protobuf enum value: CAPABILITY_TICKETING = 4;
     */
    TICKETING = 4,
    /**
     * @generated from protobuf enum value: CAPABILITY_ACCOUNT_PROVISIONING = 5;
     */
    ACCOUNT_PROVISIONING = 5,
    /**
     * @generated from protobuf enum value: CAPABILITY_CREDENTIAL_ROTATION = 6;
     */
    CREDENTIAL_ROTATION = 6,
    /**
     * @generated from protobuf enum value: CAPABILITY_RESOURCE_CREATE = 7;
     */
    RESOURCE_CREATE = 7,
    /**
     * @generated from protobuf enum value: CAPABILITY_RESOURCE_DELETE = 8;
     */
    RESOURCE_DELETE = 8,
    /**
     * @generated from protobuf enum value: CAPABILITY_SYNC_SECRETS = 9;
     */
    SYNC_SECRETS = 9,
    /**
     * @generated from protobuf enum value: CAPABILITY_ACTIONS = 10;
     */
    ACTIONS = 10,
    /**
     * @generated from protobuf enum value: CAPABILITY_TARGETED_SYNC = 11;
     */
    TARGETED_SYNC = 11,
    /**
     * @generated from protobuf enum value: CAPABILITY_EVENT_FEED_V2 = 12;
     */
    EVENT_FEED_V2 = 12,
    /**
     * @generated from protobuf enum value: CAPABILITY_SERVICE_MODE_TARGETED_SYNC = 13;
     */
    SERVICE_MODE_TARGETED_SYNC = 13
}
/**
 * @generated from protobuf enum c1.connector.v2.CapabilityDetailCredentialOption
 */
export enum CapabilityDetailCredentialOption {
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_NO_PASSWORD = 1;
     */
    NO_PASSWORD = 1,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_RANDOM_PASSWORD = 2;
     */
    RANDOM_PASSWORD = 2,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_SSO = 3;
     */
    SSO = 3,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_ENCRYPTED_PASSWORD = 4;
     */
    ENCRYPTED_PASSWORD = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCleanupRequest$Type extends MessageType<ConnectorServiceCleanupRequest> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceCleanupRequest", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 2, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceCleanupRequest>): ConnectorServiceCleanupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        message.activeSyncId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceCleanupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceCleanupRequest): ConnectorServiceCleanupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated google.protobuf.Any annotations */ 1:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string active_sync_id */ 2:
                    message.activeSyncId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceCleanupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated google.protobuf.Any annotations = 1; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string active_sync_id = 2; */
        if (message.activeSyncId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.activeSyncId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceCleanupRequest
 */
export const ConnectorServiceCleanupRequest = new ConnectorServiceCleanupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCleanupResponse$Type extends MessageType<ConnectorServiceCleanupResponse> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceCleanupResponse", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceCleanupResponse>): ConnectorServiceCleanupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceCleanupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceCleanupResponse): ConnectorServiceCleanupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated google.protobuf.Any annotations */ 1:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceCleanupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated google.protobuf.Any annotations = 1; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceCleanupResponse
 */
export const ConnectorServiceCleanupResponse = new ConnectorServiceCleanupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorMetadata$Type extends MessageType<ConnectorMetadata> {
    constructor() {
        super("c1.connector.v2.ConnectorMetadata", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", prefix: "https://", uri: true, ignoreEmpty: true } } } },
            { no: 3, name: "icon", kind: "message", T: () => AssetRef },
            { no: 4, name: "logo", kind: "message", T: () => AssetRef },
            { no: 5, name: "profile", kind: "message", T: () => Struct },
            { no: 6, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 8, name: "capabilities", kind: "message", T: () => ConnectorCapabilities },
            { no: 9, name: "account_creation_schema", kind: "message", T: () => ConnectorAccountCreationSchema }
        ]);
    }
    create(value?: PartialMessage<ConnectorMetadata>): ConnectorMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.helpUrl = "";
        message.annotations = [];
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorMetadata): ConnectorMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string help_url */ 2:
                    message.helpUrl = reader.string();
                    break;
                case /* c1.connector.v2.AssetRef icon */ 3:
                    message.icon = AssetRef.internalBinaryRead(reader, reader.uint32(), options, message.icon);
                    break;
                case /* c1.connector.v2.AssetRef logo */ 4:
                    message.logo = AssetRef.internalBinaryRead(reader, reader.uint32(), options, message.logo);
                    break;
                case /* google.protobuf.Struct profile */ 5:
                    message.profile = Struct.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                case /* repeated google.protobuf.Any annotations */ 6:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* c1.connector.v2.ConnectorCapabilities capabilities */ 8:
                    message.capabilities = ConnectorCapabilities.internalBinaryRead(reader, reader.uint32(), options, message.capabilities);
                    break;
                case /* c1.connector.v2.ConnectorAccountCreationSchema account_creation_schema */ 9:
                    message.accountCreationSchema = ConnectorAccountCreationSchema.internalBinaryRead(reader, reader.uint32(), options, message.accountCreationSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string help_url = 2; */
        if (message.helpUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.helpUrl);
        /* c1.connector.v2.AssetRef icon = 3; */
        if (message.icon)
            AssetRef.internalBinaryWrite(message.icon, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.AssetRef logo = 4; */
        if (message.logo)
            AssetRef.internalBinaryWrite(message.logo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct profile = 5; */
        if (message.profile)
            Struct.internalBinaryWrite(message.profile, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 6; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* c1.connector.v2.ConnectorCapabilities capabilities = 8; */
        if (message.capabilities)
            ConnectorCapabilities.internalBinaryWrite(message.capabilities, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ConnectorAccountCreationSchema account_creation_schema = 9; */
        if (message.accountCreationSchema)
            ConnectorAccountCreationSchema.internalBinaryWrite(message.accountCreationSchema, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorMetadata
 */
export const ConnectorMetadata = new ConnectorMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialDetails$Type extends MessageType<CredentialDetails> {
    constructor() {
        super("c1.connector.v2.CredentialDetails", [
            { no: 1, name: "capability_account_provisioning", kind: "message", T: () => CredentialDetailsAccountProvisioning },
            { no: 2, name: "capability_credential_rotation", kind: "message", T: () => CredentialDetailsCredentialRotation }
        ]);
    }
    create(value?: PartialMessage<CredentialDetails>): CredentialDetails {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CredentialDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialDetails): CredentialDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.CredentialDetailsAccountProvisioning capability_account_provisioning */ 1:
                    message.capabilityAccountProvisioning = CredentialDetailsAccountProvisioning.internalBinaryRead(reader, reader.uint32(), options, message.capabilityAccountProvisioning);
                    break;
                case /* c1.connector.v2.CredentialDetailsCredentialRotation capability_credential_rotation */ 2:
                    message.capabilityCredentialRotation = CredentialDetailsCredentialRotation.internalBinaryRead(reader, reader.uint32(), options, message.capabilityCredentialRotation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.CredentialDetailsAccountProvisioning capability_account_provisioning = 1; */
        if (message.capabilityAccountProvisioning)
            CredentialDetailsAccountProvisioning.internalBinaryWrite(message.capabilityAccountProvisioning, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CredentialDetailsCredentialRotation capability_credential_rotation = 2; */
        if (message.capabilityCredentialRotation)
            CredentialDetailsCredentialRotation.internalBinaryWrite(message.capabilityCredentialRotation, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialDetails
 */
export const CredentialDetails = new CredentialDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialDetailsAccountProvisioning$Type extends MessageType<CredentialDetailsAccountProvisioning> {
    constructor() {
        super("c1.connector.v2.CredentialDetailsAccountProvisioning", [
            { no: 1, name: "supported_credential_options", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] },
            { no: 2, name: "preferred_credential_option", kind: "enum", T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] }
        ]);
    }
    create(value?: PartialMessage<CredentialDetailsAccountProvisioning>): CredentialDetailsAccountProvisioning {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.supportedCredentialOptions = [];
        message.preferredCredentialOption = 0;
        if (value !== undefined)
            reflectionMergePartial<CredentialDetailsAccountProvisioning>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialDetailsAccountProvisioning): CredentialDetailsAccountProvisioning {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.supportedCredentialOptions.push(reader.int32());
                    else
                        message.supportedCredentialOptions.push(reader.int32());
                    break;
                case /* c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option */ 2:
                    message.preferredCredentialOption = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialDetailsAccountProvisioning, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options = 1; */
        if (message.supportedCredentialOptions.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.supportedCredentialOptions.length; i++)
                writer.int32(message.supportedCredentialOptions[i]);
            writer.join();
        }
        /* c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option = 2; */
        if (message.preferredCredentialOption !== 0)
            writer.tag(2, WireType.Varint).int32(message.preferredCredentialOption);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialDetailsAccountProvisioning
 */
export const CredentialDetailsAccountProvisioning = new CredentialDetailsAccountProvisioning$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialDetailsCredentialRotation$Type extends MessageType<CredentialDetailsCredentialRotation> {
    constructor() {
        super("c1.connector.v2.CredentialDetailsCredentialRotation", [
            { no: 1, name: "supported_credential_options", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] },
            { no: 2, name: "preferred_credential_option", kind: "enum", T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] }
        ]);
    }
    create(value?: PartialMessage<CredentialDetailsCredentialRotation>): CredentialDetailsCredentialRotation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.supportedCredentialOptions = [];
        message.preferredCredentialOption = 0;
        if (value !== undefined)
            reflectionMergePartial<CredentialDetailsCredentialRotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialDetailsCredentialRotation): CredentialDetailsCredentialRotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.supportedCredentialOptions.push(reader.int32());
                    else
                        message.supportedCredentialOptions.push(reader.int32());
                    break;
                case /* c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option */ 2:
                    message.preferredCredentialOption = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialDetailsCredentialRotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options = 1; */
        if (message.supportedCredentialOptions.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.supportedCredentialOptions.length; i++)
                writer.int32(message.supportedCredentialOptions[i]);
            writer.join();
        }
        /* c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option = 2; */
        if (message.preferredCredentialOption !== 0)
            writer.tag(2, WireType.Varint).int32(message.preferredCredentialOption);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialDetailsCredentialRotation
 */
export const CredentialDetailsCredentialRotation = new CredentialDetailsCredentialRotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCapabilities$Type extends MessageType<ConnectorCapabilities> {
    constructor() {
        super("c1.connector.v2.ConnectorCapabilities", [
            { no: 1, name: "resource_type_capabilities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceTypeCapability },
            { no: 2, name: "connector_capabilities", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.Capability", Capability, "CAPABILITY_"] },
            { no: 3, name: "credential_details", kind: "message", T: () => CredentialDetails }
        ]);
    }
    create(value?: PartialMessage<ConnectorCapabilities>): ConnectorCapabilities {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceTypeCapabilities = [];
        message.connectorCapabilities = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorCapabilities>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCapabilities): ConnectorCapabilities {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.ResourceTypeCapability resource_type_capabilities */ 1:
                    message.resourceTypeCapabilities.push(ResourceTypeCapability.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.connector.v2.Capability connector_capabilities */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.connectorCapabilities.push(reader.int32());
                    else
                        message.connectorCapabilities.push(reader.int32());
                    break;
                case /* c1.connector.v2.CredentialDetails credential_details */ 3:
                    message.credentialDetails = CredentialDetails.internalBinaryRead(reader, reader.uint32(), options, message.credentialDetails);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCapabilities, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.ResourceTypeCapability resource_type_capabilities = 1; */
        for (let i = 0; i < message.resourceTypeCapabilities.length; i++)
            ResourceTypeCapability.internalBinaryWrite(message.resourceTypeCapabilities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.Capability connector_capabilities = 2; */
        if (message.connectorCapabilities.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.connectorCapabilities.length; i++)
                writer.int32(message.connectorCapabilities[i]);
            writer.join();
        }
        /* c1.connector.v2.CredentialDetails credential_details = 3; */
        if (message.credentialDetails)
            CredentialDetails.internalBinaryWrite(message.credentialDetails, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorCapabilities
 */
export const ConnectorCapabilities = new ConnectorCapabilities$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CapabilityPermission$Type extends MessageType<CapabilityPermission> {
    constructor() {
        super("c1.connector.v2.CapabilityPermission", [
            { no: 1, name: "permission", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CapabilityPermission>): CapabilityPermission {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permission = "";
        if (value !== undefined)
            reflectionMergePartial<CapabilityPermission>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CapabilityPermission): CapabilityPermission {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string permission */ 1:
                    message.permission = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CapabilityPermission, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string permission = 1; */
        if (message.permission !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.permission);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CapabilityPermission
 */
export const CapabilityPermission = new CapabilityPermission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CapabilityPermissions$Type extends MessageType<CapabilityPermissions> {
    constructor() {
        super("c1.connector.v2.CapabilityPermissions", [
            { no: 1, name: "permissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CapabilityPermission }
        ]);
    }
    create(value?: PartialMessage<CapabilityPermissions>): CapabilityPermissions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permissions = [];
        if (value !== undefined)
            reflectionMergePartial<CapabilityPermissions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CapabilityPermissions): CapabilityPermissions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.CapabilityPermission permissions */ 1:
                    message.permissions.push(CapabilityPermission.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CapabilityPermissions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.CapabilityPermission permissions = 1; */
        for (let i = 0; i < message.permissions.length; i++)
            CapabilityPermission.internalBinaryWrite(message.permissions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CapabilityPermissions
 */
export const CapabilityPermissions = new CapabilityPermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeCapability$Type extends MessageType<ResourceTypeCapability> {
    constructor() {
        super("c1.connector.v2.ResourceTypeCapability", [
            { no: 1, name: "resource_type", kind: "message", T: () => ResourceType },
            { no: 2, name: "capabilities", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.Capability", Capability, "CAPABILITY_"] },
            { no: 3, name: "permissions", kind: "message", T: () => CapabilityPermissions }
        ]);
    }
    create(value?: PartialMessage<ResourceTypeCapability>): ResourceTypeCapability {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.capabilities = [];
        if (value !== undefined)
            reflectionMergePartial<ResourceTypeCapability>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceTypeCapability): ResourceTypeCapability {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.ResourceType resource_type */ 1:
                    message.resourceType = ResourceType.internalBinaryRead(reader, reader.uint32(), options, message.resourceType);
                    break;
                case /* repeated c1.connector.v2.Capability capabilities */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.capabilities.push(reader.int32());
                    else
                        message.capabilities.push(reader.int32());
                    break;
                case /* c1.connector.v2.CapabilityPermissions permissions */ 3:
                    message.permissions = CapabilityPermissions.internalBinaryRead(reader, reader.uint32(), options, message.permissions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceTypeCapability, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.ResourceType resource_type = 1; */
        if (message.resourceType)
            ResourceType.internalBinaryWrite(message.resourceType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.Capability capabilities = 2; */
        if (message.capabilities.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.capabilities.length; i++)
                writer.int32(message.capabilities[i]);
            writer.join();
        }
        /* c1.connector.v2.CapabilityPermissions permissions = 3; */
        if (message.permissions)
            CapabilityPermissions.internalBinaryWrite(message.permissions, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceTypeCapability
 */
export const ResourceTypeCapability = new ResourceTypeCapability$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetMetadataRequest$Type extends MessageType<ConnectorServiceGetMetadataRequest> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceGetMetadataRequest", []);
    }
    create(value?: PartialMessage<ConnectorServiceGetMetadataRequest>): ConnectorServiceGetMetadataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceGetMetadataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceGetMetadataRequest): ConnectorServiceGetMetadataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceGetMetadataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceGetMetadataRequest
 */
export const ConnectorServiceGetMetadataRequest = new ConnectorServiceGetMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetMetadataResponse$Type extends MessageType<ConnectorServiceGetMetadataResponse> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceGetMetadataResponse", [
            { no: 1, name: "metadata", kind: "message", T: () => ConnectorMetadata }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceGetMetadataResponse>): ConnectorServiceGetMetadataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceGetMetadataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceGetMetadataResponse): ConnectorServiceGetMetadataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.ConnectorMetadata metadata */ 1:
                    message.metadata = ConnectorMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceGetMetadataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.ConnectorMetadata metadata = 1; */
        if (message.metadata)
            ConnectorMetadata.internalBinaryWrite(message.metadata, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceGetMetadataResponse
 */
export const ConnectorServiceGetMetadataResponse = new ConnectorServiceGetMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceValidateRequest$Type extends MessageType<ConnectorServiceValidateRequest> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceValidateRequest", []);
    }
    create(value?: PartialMessage<ConnectorServiceValidateRequest>): ConnectorServiceValidateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceValidateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceValidateRequest): ConnectorServiceValidateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceValidateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceValidateRequest
 */
export const ConnectorServiceValidateRequest = new ConnectorServiceValidateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceValidateResponse$Type extends MessageType<ConnectorServiceValidateResponse> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceValidateResponse", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 2, name: "sdk_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorServiceValidateResponse>): ConnectorServiceValidateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        message.sdkVersion = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorServiceValidateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorServiceValidateResponse): ConnectorServiceValidateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated google.protobuf.Any annotations */ 1:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string sdk_version */ 2:
                    message.sdkVersion = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorServiceValidateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated google.protobuf.Any annotations = 1; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sdk_version = 2; */
        if (message.sdkVersion !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sdkVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceValidateResponse
 */
export const ConnectorServiceValidateResponse = new ConnectorServiceValidateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema$Type extends MessageType<ConnectorAccountCreationSchema> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema", [
            { no: 1, name: "field_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema>): ConnectorAccountCreationSchema {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fieldMap = {};
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema): ConnectorAccountCreationSchema {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> field_map */ 1:
                    this.binaryReadMap1(message.fieldMap, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: ConnectorAccountCreationSchema["fieldMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConnectorAccountCreationSchema["fieldMap"] | undefined, val: ConnectorAccountCreationSchema["fieldMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ConnectorAccountCreationSchema_Field.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.connector.v2.ConnectorAccountCreationSchema.field_map");
            }
        }
        map[key ?? ""] = val ?? ConnectorAccountCreationSchema_Field.create();
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> field_map = 1; */
        for (let k of globalThis.Object.keys(message.fieldMap)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ConnectorAccountCreationSchema_Field.internalBinaryWrite(message.fieldMap[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema
 */
export const ConnectorAccountCreationSchema = new ConnectorAccountCreationSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_Field$Type extends MessageType<ConnectorAccountCreationSchema_Field> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.Field", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "deprecated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "string_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringField },
            { no: 101, name: "bool_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_BoolField },
            { no: 102, name: "string_list_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringListField },
            { no: 103, name: "int_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_IntField },
            { no: 104, name: "map_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_MapField }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_Field>): ConnectorAccountCreationSchema_Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.required = false;
        message.description = "";
        message.placeholder = "";
        message.order = 0;
        message.deprecated = false;
        message.field = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_Field): ConnectorAccountCreationSchema_Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* bool required */ 2:
                    message.required = reader.bool();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string placeholder */ 4:
                    message.placeholder = reader.string();
                    break;
                case /* int32 order */ 5:
                    message.order = reader.int32();
                    break;
                case /* bool deprecated */ 6:
                    message.deprecated = reader.bool();
                    break;
                case /* c1.connector.v2.ConnectorAccountCreationSchema.StringField string_field */ 100:
                    message.field = {
                        oneofKind: "stringField",
                        stringField: ConnectorAccountCreationSchema_StringField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).stringField)
                    };
                    break;
                case /* c1.connector.v2.ConnectorAccountCreationSchema.BoolField bool_field */ 101:
                    message.field = {
                        oneofKind: "boolField",
                        boolField: ConnectorAccountCreationSchema_BoolField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).boolField)
                    };
                    break;
                case /* c1.connector.v2.ConnectorAccountCreationSchema.StringListField string_list_field */ 102:
                    message.field = {
                        oneofKind: "stringListField",
                        stringListField: ConnectorAccountCreationSchema_StringListField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).stringListField)
                    };
                    break;
                case /* c1.connector.v2.ConnectorAccountCreationSchema.IntField int_field */ 103:
                    message.field = {
                        oneofKind: "intField",
                        intField: ConnectorAccountCreationSchema_IntField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).intField)
                    };
                    break;
                case /* c1.connector.v2.ConnectorAccountCreationSchema.MapField map_field */ 104:
                    message.field = {
                        oneofKind: "mapField",
                        mapField: ConnectorAccountCreationSchema_MapField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).mapField)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* bool required = 2; */
        if (message.required !== false)
            writer.tag(2, WireType.Varint).bool(message.required);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string placeholder = 4; */
        if (message.placeholder !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.placeholder);
        /* int32 order = 5; */
        if (message.order !== 0)
            writer.tag(5, WireType.Varint).int32(message.order);
        /* bool deprecated = 6; */
        if (message.deprecated !== false)
            writer.tag(6, WireType.Varint).bool(message.deprecated);
        /* c1.connector.v2.ConnectorAccountCreationSchema.StringField string_field = 100; */
        if (message.field.oneofKind === "stringField")
            ConnectorAccountCreationSchema_StringField.internalBinaryWrite(message.field.stringField, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ConnectorAccountCreationSchema.BoolField bool_field = 101; */
        if (message.field.oneofKind === "boolField")
            ConnectorAccountCreationSchema_BoolField.internalBinaryWrite(message.field.boolField, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ConnectorAccountCreationSchema.StringListField string_list_field = 102; */
        if (message.field.oneofKind === "stringListField")
            ConnectorAccountCreationSchema_StringListField.internalBinaryWrite(message.field.stringListField, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ConnectorAccountCreationSchema.IntField int_field = 103; */
        if (message.field.oneofKind === "intField")
            ConnectorAccountCreationSchema_IntField.internalBinaryWrite(message.field.intField, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ConnectorAccountCreationSchema.MapField map_field = 104; */
        if (message.field.oneofKind === "mapField")
            ConnectorAccountCreationSchema_MapField.internalBinaryWrite(message.field.mapField, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.Field
 */
export const ConnectorAccountCreationSchema_Field = new ConnectorAccountCreationSchema_Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringField$Type extends MessageType<ConnectorAccountCreationSchema_StringField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.StringField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_StringField>): ConnectorAccountCreationSchema_StringField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_StringField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_StringField): ConnectorAccountCreationSchema_StringField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string default_value */ 1:
                    message.defaultValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_StringField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string default_value = 1; */
        if (message.defaultValue !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringField
 */
export const ConnectorAccountCreationSchema_StringField = new ConnectorAccountCreationSchema_StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_BoolField$Type extends MessageType<ConnectorAccountCreationSchema_BoolField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.BoolField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_BoolField>): ConnectorAccountCreationSchema_BoolField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_BoolField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_BoolField): ConnectorAccountCreationSchema_BoolField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool default_value */ 1:
                    message.defaultValue = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_BoolField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional bool default_value = 1; */
        if (message.defaultValue !== undefined)
            writer.tag(1, WireType.Varint).bool(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.BoolField
 */
export const ConnectorAccountCreationSchema_BoolField = new ConnectorAccountCreationSchema_BoolField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringListField$Type extends MessageType<ConnectorAccountCreationSchema_StringListField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.StringListField", [
            { no: 1, name: "default_value", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_StringListField>): ConnectorAccountCreationSchema_StringListField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValue = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_StringListField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_StringListField): ConnectorAccountCreationSchema_StringListField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string default_value */ 1:
                    message.defaultValue.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_StringListField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string default_value = 1; */
        for (let i = 0; i < message.defaultValue.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValue[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringListField
 */
export const ConnectorAccountCreationSchema_StringListField = new ConnectorAccountCreationSchema_StringListField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_IntField$Type extends MessageType<ConnectorAccountCreationSchema_IntField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.IntField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_IntField>): ConnectorAccountCreationSchema_IntField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_IntField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_IntField): ConnectorAccountCreationSchema_IntField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int32 default_value */ 1:
                    message.defaultValue = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_IntField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int32 default_value = 1; */
        if (message.defaultValue !== undefined)
            writer.tag(1, WireType.Varint).int32(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.IntField
 */
export const ConnectorAccountCreationSchema_IntField = new ConnectorAccountCreationSchema_IntField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_MapField$Type extends MessageType<ConnectorAccountCreationSchema_MapField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.MapField", [
            { no: 1, name: "default_value", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } }
        ]);
    }
    create(value?: PartialMessage<ConnectorAccountCreationSchema_MapField>): ConnectorAccountCreationSchema_MapField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValue = {};
        if (value !== undefined)
            reflectionMergePartial<ConnectorAccountCreationSchema_MapField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorAccountCreationSchema_MapField): ConnectorAccountCreationSchema_MapField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> default_value */ 1:
                    this.binaryReadMap1(message.defaultValue, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: ConnectorAccountCreationSchema_MapField["defaultValue"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ConnectorAccountCreationSchema_MapField["defaultValue"] | undefined, val: ConnectorAccountCreationSchema_MapField["defaultValue"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ConnectorAccountCreationSchema_Field.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.connector.v2.ConnectorAccountCreationSchema.MapField.default_value");
            }
        }
        map[key ?? ""] = val ?? ConnectorAccountCreationSchema_Field.create();
    }
    internalBinaryWrite(message: ConnectorAccountCreationSchema_MapField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> default_value = 1; */
        for (let k of globalThis.Object.keys(message.defaultValue)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ConnectorAccountCreationSchema_Field.internalBinaryWrite(message.defaultValue[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.MapField
 */
export const ConnectorAccountCreationSchema_MapField = new ConnectorAccountCreationSchema_MapField$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ConnectorService
 */
export const ConnectorService = new ServiceType("c1.connector.v2.ConnectorService", [
    { name: "GetMetadata", options: {}, I: ConnectorServiceGetMetadataRequest, O: ConnectorServiceGetMetadataResponse },
    { name: "Validate", options: {}, I: ConnectorServiceValidateRequest, O: ConnectorServiceValidateResponse },
    { name: "Cleanup", options: {}, I: ConnectorServiceCleanupRequest, O: ConnectorServiceCleanupResponse }
]);
